import { Injectable } from '@angular/core';
import {Contract, ContractForm, MiscellaneousContractForm} from '../models/contract';
import {Site} from '../../shared/models/site';
import {MiscellaneousSiteForm} from '../../site/models/site-form';
import {DateFormatService} from '../../shared/services/date-format.service';

@Injectable({
  providedIn: 'root'
})
export class ContractMapperService {

  constructor(private dateFormatService: DateFormatService) { }

  contractDbToForm(contract: Contract): ContractForm {
    return {
      invoicing: {
        start: contract.start ?  contract.start : null,
        end: contract.end ? contract.end : null,
      },
      // isIndex: { isIndex: contract.isIndex },
      // isPORequired: { isPORequired: contract.isPORequired },
      setting : { isIndex: contract.isIndex , isPORequired: contract.isPORequired , isPeriodicAdjustment: contract.isPeriodicAdjustment },
      customInvoice: { customInvoice: contract.customInvoice },
      triggerStart: { triggerStart: {id: contract.triggerStart, name: null }  },
      delay: {
        retractationDelay: contract.retractationDelay,
        paymentDelay: contract.paymentDelay ,
      },
      productID: { productID: {id: contract.productID, name: null } },
      recurrence: {
        recurrence: {id: contract.recurrence,  name: null } ,
        billingShiftMonth: contract.billingShiftMonth,
        billingShiftDay: contract.billingShiftDay,
        allowShiftMonth: contract.billingShiftMonth ? true : false,
      },
      split: { split: { id: contract.split, name: null } },
      sla: { sla:  {id: contract.sla,  name: null }  },
      currency: { currency:  {id: contract.currency,  name: null }  },
      displayName: { displayName: contract.sufix },
      prefix:  contract.prefix ,
      info: {
        created: contract.created,
        createdBy: contract.createdBy,
        updated: contract.updated,
        updatedBy: contract.updatedBy
      },
      id: contract.id,
      name: contract.name,
      uuid: contract.uuid,
      deleted: contract.deleted
    }
  }

  miscellaneousDbToForm(contractForm: Contract): MiscellaneousContractForm {
    return {
      information: {
        created: this.dateFormatService.stringToFullDateTime(contractForm.created),
        createdBy: '',
        updated: this.dateFormatService.stringToFullDateTime(contractForm.updated),
        updatedBy: '',
      },
      commentsForm: {
        commentsBlog: contractForm ? contractForm.comments : null,
        comments: ''
      }
    }
  }

  contractFormToDb(contractForm: ContractForm): Contract {
    // @ts-ignore
    return {
      'uuid': contractForm.uuid ? contractForm.uuid : null,
      'start': contractForm.invoicing.start ,
      'end': contractForm.invoicing.end ,
      'isIndex': contractForm.setting.isIndex,
      'isPeriodicAdjustment': contractForm.setting.isPeriodicAdjustment  ? true : false,
      'isPORequired': contractForm.setting.isPORequired,
      'recurrence': contractForm.recurrence.recurrence.id,
      'billingShiftMonth': contractForm.recurrence.allowShiftMonth ?  contractForm.recurrence.billingShiftMonth : null,
      'billingShiftDay': contractForm.recurrence.allowShiftMonth ?
        // @ts-ignore
        (contractForm.recurrence.billingShiftDay === 1 ? null : contractForm.recurrence.billingShiftDay )  : null,
      'split': contractForm.split.split.id,
      'productID': contractForm.productID.productID.id,
      'sla': contractForm.sla.sla.id,
      'customInvoice': contractForm.customInvoice.customInvoice,
      'retractationDelay': contractForm.delay.retractationDelay,
      'paymentDelay': contractForm.delay.paymentDelay,
      'deleted': contractForm.deleted,
      'currency': contractForm.currency.currency.id,
      'triggerStart': contractForm.triggerStart.triggerStart.id,
      'id': contractForm.id,
      'name': contractForm.displayName.displayName,
      'displayName': contractForm.prefix + (contractForm.displayName.displayName ? contractForm.displayName.displayName : ''),
      'prefix': contractForm.prefix,
      'sufix': contractForm.displayName.displayName ? contractForm.displayName.displayName : '',
    }
  }
}
